class Model {
	id
	constructor({id}) {
		this.id = id;
	}
}

export default Model;